import { render, staticRenderFns } from "./CustomerRegistrationResponsible.vue?vue&type=template&id=8e5152b0"
import script from "./CustomerRegistrationResponsible.vue?vue&type=script&lang=js"
export * from "./CustomerRegistrationResponsible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports